import {IPlugin} from "./IPlugin";

export class PluginRepository {
    static async loadPlugin(pluginName: string): Promise<IPlugin> {
        switch (pluginName) {
            case "facebook": {
                let module = await import("./FacebookPlugin");

                return new module.FacebookPlugin();
            }

            default:
                throw new Error(`Plugin ${pluginName} is not supported`);
        }
    };
}



// WEBPACK FOOTER //
// ./plugins/PluginRepository.ts